import {Component} from '@angular/core';
import {Events, NavParams, ViewController} from 'ionic-angular';

/**
 * Generated class for the ConflictManagementPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-conflict-management',
  templateUrl: 'conflict-management.html',
})
export class ConflictManagementPage {

  private leftSide: any;
  private rightSide: any;
  private docType: string;

  private docInfosLeftSide: any;
  private docInfosRightSide: any
  private docTitle: String;

  constructor(public viewCtrl: ViewController, public navParams: NavParams, private events: Events) {
    this.leftSide = this.navParams.get('leftSide');
    this.rightSide = this.navParams.get('rightSide');
    this.docType = this.leftSide.docType;

    this.events.subscribe('conflict:'+this.leftSide._id, () => {
      //new Conflict, close this Modal;
      this.viewCtrl.dismiss();
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ConflictManagementPage');

    this.docInfosLeftSide.docName = this.leftSide.docName;
    this.docInfosRightSide.docName = this.rightSide.docName;

    switch(this.docType) {
      case 'contact':
        this.docInfosLeftSide.Firma = this.leftSide.company;
        this.docInfosLeftSide.Vorname = this.leftSide.firstName;
        this.docInfosLeftSide.Nachname = this.leftSide.lastName;

        this.docInfosRightSide.Firma = this.rightSide.company;
        this.docInfosRightSide.Vorname = this.rightSide.firstName;
        this.docInfosRightSide.Nachname = this.rightSide.lastName;
        break;
      case 'template':
        this.docInfosLeftSide.Titel = this.leftSide.title;
        this.docInfosLeftSide.Pruefpunkte = [];
        this.docInfosLeftSide.Pruefergebnisse = []

        this.docInfosRightSide.Titel = this.rightSide.title;
        this.docInfosRightSide.Pruefpunkte = [];
        this.docInfosRightSide.Pruefergebnisse = []

        this.leftSide.pruefpunkte.forEach((pruefpunkt) => {
          this.docInfosLeftSide.pruefpunkte.push(pruefpunkt.title);
        });
        this.rightSide.pruefpunkte.forEach((pruefpunkt) => {
          this.docInfosRightSide.pruefpunkte.push(pruefpunkt.title);
        });
        break;
      case 'location':
        break;
      case 'note':
        break;
      case 'remark':
        break;
      case 'audit':
        break;
      case 'protocol':
        break;
    }

  }

  public deleteOtherSide(id, rev): void {
    this.viewCtrl.dismiss({id: id, rev: rev});
  }

}



// WEBPACK FOOTER //
// ./src/pages/conflict-management/conflict-management.ts